/**
 * desktop-scroll.js
 *
 * Enables mouse wheel and drag-based scrolling on the product detail page's
 * left-hand information column when viewed on desktop widths (750px and
 * above).  The script locates the `.product__sticky-scroll` element
 * contained within the sticky product info column and binds listeners to
 * handle wheel and mouse drag events.  It ensures that the scroll
 * interactions are restricted to the column itself and do not interfere
 * with interactive elements such as buttons, links, form controls, or
 * select dropdowns.
 */

(function() {
  function initDesktopScroll() {
    // Only run on larger screens
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    // Locate the element to scroll: prefer the inner `.product__sticky-scroll` wrapper if present
    var scrollEl = document.querySelector('.product__sticky-scroll');
    // Fallback to the sticky column itself if the wrapper is absent.  This ensures
    // that the script still works even if the Liquid template was not updated.
    if (!scrollEl) {
      scrollEl = document.querySelector('.product__column-sticky');
    }
    if (!scrollEl) return;

    // Prevent rebinding if already bound
    if (scrollEl.dataset.desktopScrollBound === '1') return;
    scrollEl.dataset.desktopScrollBound = '1';

    // Wheel scrolling: adjust scrollTop and prevent default when there is
    // overflow so the page doesn't capture the scroll instead.
    scrollEl.addEventListener('wheel', function(e) {
      // Ignore when using interactive elements
      var interactive = e.target.closest('a, button, select, option, input, textarea, label, [contenteditable="true"]');
      if (interactive) return;
      if (scrollEl.scrollHeight > scrollEl.clientHeight) {
        e.preventDefault();
        scrollEl.scrollTop += e.deltaY;
      }
    }, { passive: false });

    // Drag to scroll (click and hold left mouse button)
    var isDragging = false;
    var startY = 0;
    var startScroll = 0;

    scrollEl.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      // Don't start drag on interactive elements
      var interactive = e.target.closest('a, button, select, option, input, textarea, label, [contenteditable="true"]');
      if (interactive) return;
      if (scrollEl.scrollHeight <= scrollEl.clientHeight) return;
      isDragging = true;
      startY = e.pageY;
      startScroll = scrollEl.scrollTop;
      scrollEl.classList.add('is-dragging');
      e.preventDefault();
    });
    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      var dy = e.pageY - startY;
      scrollEl.scrollTop = startScroll - dy;
    });
    window.addEventListener('mouseup', function() {
      if (isDragging) {
        isDragging = false;
        scrollEl.classList.remove('is-dragging');
      }
    });
  }

  // Run on DOMContentLoaded and on dynamic page load events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopScroll);
  } else {
    initDesktopScroll();
  }

  // Also respond to Shopify's Section rendering events (Shopify AJAX reload)
  document.addEventListener('shopify:section:load', initDesktopScroll);
})();